/* eslint-disable no-console */

/**
 * @module M/control/GetFeatInfControl
 */

import GetFeatInfImplControl from 'impl/getfeatinfcontrol';
import template from 'templates/getfeatinf';

export default class GetFeatInfControl extends M.Control {
  /**
   * @classdesc
   * Main constructor of the class. Creates a PluginControl
   * control
   *
   * @constructor
   * @extends {M.Control}
   * @api stable
   */
  constructor() {
    // 1. checks if the implementation can create PluginControl
    if (M.utils.isUndefined(GetFeatInfImplControl)) {
      M.exception('La implementación usada no puede crear controles GetFeatInfControl');
    }
    // 2. implementation of this control
    const impl = new GetFeatInfImplControl();
    super(impl, 'GetFeatInf');

    this.ListLayers = [
      {
        type: 'WMS',
        layers: []
      },
      {
        type: 'WMTS',
        layers: []
      },
      {
        type: 'WFS',
        layers: []
      },
      {
        type: 'GeoJSON',
        layers: []
      }
    ]
  }

  /**
   * This function creates the view
   *
   * @public
   * @function
   * @param {M.Map} map to add the control
   * @api stable
   */
  createView(map) {
    if (!M.template.compileSync) { // JGL: retrocompatibilidad Mapea4
      M.template.compileSync = (string, options) => {
        let templateCompiled;
        let templateVars = {};
        let parseToHtml;
        if (!M.utils.isUndefined(options)) {
          templateVars = M.utils.extends(templateVars, options.vars);
          parseToHtml = options.parseToHtml;
        }
        const templateFn = Handlebars.compile(string);
        const htmlText = templateFn(templateVars);
        if (parseToHtml !== false) {
          templateCompiled = M.utils.stringToHtml(htmlText);
        } else {
          templateCompiled = htmlText;
        }
        return templateCompiled;
      };
    }

    return new Promise((success, fail) => {
      const html = M.template.compileSync(template);
      // Añadir código dependiente del DOM

      this.addEvents(html);
      success(html);
    });
  }

  /**
   * This function is called on the control activation
   *
   * @public
   * @function
   * @api stable
   */
  activate() {
    // calls super to manage activation
    super.activate();    

    //  Si hay algún feature seleccionado lo deseleccionamos

    this.map_.getFeatureHandler().clearSelectedFeatures();

    this.ListLayers.filter(obj => obj.type == 'WFS')[0].layers.forEach((nameLayer) => {
      this.map_.getLayers({ name: nameLayer })[0].getImpl().extract = true;
      this.map_.getLayers({ name: nameLayer })[0].getImpl().refresh();
    });

    this.ListLayers.filter(obj => obj.type == 'GeoJSON')[0].layers.forEach((nameLayer) => {   
      
      this.map_.getLayers({ name: nameLayer })[0].getImpl().extract = true;      
      
    });

    

  }


  /**
   * This function is called on the control deactivation
   *
   * @public
   * @function
   * @api stable
   */


  deactivate() {
    // calls super to manage deactivation
    super.deactivate();
    

    //  Si hay algún popup en el mapa lo eliminamos al desactivar el control

    if (this.map_.getPopup()) {
      this.map_.removePopup();
    }

    //  Si hay algún feature seleccionado lo deseleccionamos

    this.map_.getFeatureHandler().clearSelectedFeatures();


    this.ListLayers.filter(obj => obj.type == 'WFS')[0].layers.forEach((nameLayer) => {
      this.map_.getLayers({ name: nameLayer })[0].getImpl().extract = false;
      this.map_.getLayers({ name: nameLayer })[0].getImpl().refresh();
    });

    this.ListLayers.filter(obj => obj.type == 'GeoJSON')[0].layers.forEach((nameLayer) => {      
      this.map_.getLayers({ name: nameLayer })[0].getImpl().extract = false;      
    });

  }
  /**
   * This function gets activation button
   *
   * @public
   * @function
   * @param {HTML} html of control
   * @api stable
   */
  getActivationButton(html) {
    return html.querySelector('.m-getfeatinf button');
  }

  /**
   * This function compares controls
   *
   * @public
   * @function
   * @param {M.Control} control to compare
   * @api stable
   */
  equals(control) {
    return control instanceof GetFeatInfControl;
  }

  // Add your own functions

  addEvents(html) {
    this.map_.on(M.evt.CLICK, (evt) => {

      if (this.panel_.getControls()[0].activated) {
        let objectsSelected = false;

        //  forzamos a que solamente muestre un popup si el objeto seleccionado no es un cluster  

        if (Object.entries(this.map_.getFeatureHandler().prevSelectedFeatures_).filter(obj => obj[1].length != 0).length) {   // hemos hecho click sobre un elemento WFS o GeoJSON

          if (Object.entries(this.map_.getFeatureHandler().prevSelectedFeatures_).filter(obj => obj[1].length != 0).filter(obj => obj[1][0] instanceof M.ClusteredFeature).length == 0) {
            objectsSelected = Object.entries(this.map_.getFeatureHandler().prevSelectedFeatures_).filter(obj => obj[1].length != 0).filter(obj => !(obj[1][0] instanceof M.ClusteredFeature))[0][1][0];
          } else {
            objectsSelected = false;
          }
        } else {  // hemos hecho click sobre un WMS
          objectsSelected = true;
        }

        // if(!objectsSelected){

        // }

        if (objectsSelected) {
          if (!(objectsSelected instanceof M.ClusteredFeature)) { // si no es cluster abre popup
            var elemPopup = null;

            let source;
            let url;
            let viewResolution = this.map_.getMapImpl().getView().getResolution();
            let srs = this.map_.getProjection().code;

            let coord = evt.coord;

            var popup = this.map_.getPopup() || new M.Popup();            

            if (this.map_.getPopup()) { // ocultamos el popup hasta que devuelvan la información todas las capas
              elemPopup = this.map_.getPopup().element_;
              elemPopup.style.display = 'none';
            }

            let getFeatureInfoParams = {
              // INFO_FORMAT: 'application/json',
              INFO_FORMAT: 'text/html',
              FEATURE_COUNT: 10
            }

            let countLayers = 0;
            this.ListLayers.forEach((group) => {
              countLayers += group.layers.length;
            });
            

            this.ListLayers.forEach((group) => {
              //  capas wms
              if (group.type == 'WMS') {
                group.layers.forEach((nameLayer) => {
                  let layer = this.map_.getLayers({ name: nameLayer })[0];
                  source = layer.getImpl().getOLLayer().getSource();
                  url = source.getFeatureInfoUrl(coord, viewResolution, srs, getFeatureInfoParams);
                  M.remote.get(url).then((res) => {                    
                    if (res.code == 200) {
                      var parser = new DOMParser();
                      var htmlDoc = parser.parseFromString(res.text, "text/html");
                      if (htmlDoc.body.children.length != 0) {

                        var featureTabOpts = {
                          'icon': 'g-cartografia-info',
                          'title': 'Título de la pestaña',
                          'content': res.text
                        };
                        popup.addTab(featureTabOpts);
                      }
                    }
                    countLayers -= 1;

                    if (countLayers == 0) {
                      if (elemPopup) {
                        elemPopup.style.display = '';
                      }
                      if (popup.tabs_.length != 0) {
                        this.map_.addPopup(popup, coord, false);
                      } else {
                        featureTabOpts = {
                          'icon': 'g-cartografia-info',
                          'title': 'Título de la pestaña',
                          'content': '<p style="text-align:center; margin-top:20px">No hay elementos consultables</p>'
                        };
                        popup.addTab(featureTabOpts);
                        this.map_.addPopup(popup, coord, false);
                      }
                    }
                  });
                });

              }
              //  capas wfs
              if (group.type == 'WFS') {
                group.layers.forEach(() => {
                  countLayers -= 1;
                  if (countLayers == 0) {
                    if (elemPopup) {
                      elemPopup.style.display = '';
                    }
                  }
                });
              }

              //  capas GeoJSON
              if (group.type == 'GeoJSON') {
                group.layers.forEach(() => {
                  countLayers -= 1;
                  if (countLayers == 0) {
                    if (elemPopup) {
                      elemPopup.style.display = '';
                    }
                  }
                });
              }

            });
          }
        } else {
          if (this.map_.getPopup()) {
            setTimeout(() => {
              this.map_.removePopup();
            }, 1);

          }
        }        
      }
    });

    this.map_.on(M.evt.POPUP_ADDED, (popup) => {  // evitamos que cada una de las pestañas tenga algún texto y dejamos solamente el icono correspondiente
      let tabs = popup.element_.querySelectorAll('div.m-tabs');
      if (tabs.length) {
        Array.from(tabs[0].children).forEach((child) => {
          child.querySelectorAll('i')[0].innerHTML = '';
        });
      }
    });

    this.map_.on(M.evt.ADDED_LAYER, (evt) => {    
      evt.forEach((e) => {        
        if (e.impl_.styles !== undefined) {
          if (e.isQueryable()) {
            if (!this.ListLayers.filter(obj => obj.type == 'WMS')[0].layers.includes(e.getImpl().name)) {
              this.ListLayers.filter(obj => obj.type == 'WMS')[0].layers.push(e.getImpl().name);
            }
          }
        }
        if (e.impl_.geometry !== undefined) {
          if (e.impl_.extract == true) {
            if (!this.ListLayers.filter(obj => obj.type == 'WFS')[0].layers.includes(e.getImpl().name)) {
              if (this.panel_.getControls()[0].activated) {
                e.impl_.extract = true;
              } else {
                e.impl_.extract = false;
              }
              this.ListLayers.filter(obj => obj.type == 'WFS')[0].layers.push(e.getImpl().name);

            }
          }
        }
        if (e.impl_.source !== undefined) {
          if (e.impl_.extract == true) {
            if (!this.ListLayers.filter(obj => obj.type == 'GeoJSON')[0].layers.includes(e.getImpl().name)) {
              if (this.panel_.getControls()[0].activated) {
                e.impl_.extract = true;
              } else {
                e.impl_.extract = false;
              }
              this.ListLayers.filter(obj => obj.type == 'GeoJSON')[0].layers.push(e.getImpl().name);

            }
          }
        }

        if(e.impl_.url && ['outputFormat=application/json','outputFormat=json'].some(element=>e.impl_.url.includes(element))){          
          if (e.impl_.extract == true) {
            if (!this.ListLayers.filter(obj => obj.type == 'GeoJSON')[0].layers.includes(e.getImpl().name)) {
              if (this.panel_.getControls()[0].activated) {
                e.impl_.extract = true;
              } else {
                e.impl_.extract = false;
              }
              this.ListLayers.filter(obj => obj.type == 'GeoJSON')[0].layers.push(e.getImpl().name);

            }
          }
        }
        
      });
      
    });    

    this.map_.on(M.evt.REMOVED_LAYER, (evt) => {           
      evt.forEach((e) => {        
        if (e.impl_.styles !== undefined) {
          this.ListLayers.filter(obj => obj.type == 'WMS')[0].layers = this.ListLayers.filter(obj => obj.type == 'WMS')[0].layers.filter(obj => obj != e.getImpl().name);
        }
        if (e.impl_.geometry !== undefined) {
          this.ListLayers.filter(obj => obj.type == 'WFS')[0].layers = this.ListLayers.filter(obj => obj.type == 'WFS')[0].layers.filter(obj => obj != e.getImpl().name);
        }
        if (e.impl_.source !== undefined) {
          this.ListLayers.filter(obj => obj.type == 'GeoJSON')[0].layers = this.ListLayers.filter(obj => obj.type == 'GeoJSON')[0].layers.filter(obj => obj != e.getImpl().name);
        }

        if(e.impl_.url && ['outputFormat=application/json','outputFormat=json'].some(element=>e.impl_.url.includes(element))){ 
          this.ListLayers.filter(obj => obj.type == 'GeoJSON')[0].layers = this.ListLayers.filter(obj => obj.type == 'GeoJSON')[0].layers.filter(obj => obj != e.getImpl().name);
        }
      });      
    });

    this.map_.on(M.evt.COMPLETED, () => {
      let loadedLayers = this.map_.getLayers();

      loadedLayers.forEach((layer) => {
        if (layer.impl_.styles !== undefined) {
          if (layer.isQueryable()) {
            if (!this.ListLayers.filter(obj => obj.type == 'WMS')[0].layers.includes(layer.getImpl().name)) {
              this.ListLayers.filter(obj => obj.type == 'WMS')[0].layers.push(layer.getImpl().name);
            }
          }
        }
        // if (layer.impl_.matrixSet !== undefined) {
        //   // if (layer.isQueryable()) {
        //     if (!this.ListLayers.filter(obj => obj.type == 'WMTS')[0].layers.includes(layer.getImpl().name)) {
        //       this.ListLayers.filter(obj => obj.type == 'WMTS')[0].layers.push(layer.getImpl().name);
        //       console.log('WMTS');
        //     }
        //   // }
        // }
        if (layer.impl_.geometry !== undefined) {
          if (layer.impl_.extract == true) {
            if (!this.ListLayers.filter(obj => obj.type == 'WFS')[0].layers.includes(layer.getImpl().name)) {
              if (this.panel_.getControls()[0].activated) {
                layer.impl_.extract = true;
              } else {
                layer.impl_.extract = false;
              }
              this.ListLayers.filter(obj => obj.type == 'WFS')[0].layers.push(layer.getImpl().name);

            }
          }
        }
        if (layer.impl_.source !== undefined) {
          if (layer.impl_.extract == true) {
            if (!this.ListLayers.filter(obj => obj.type == 'GeoJSON')[0].layers.includes(layer.getImpl().name)) {
              if (this.panel_.getControls()[0].activated) {
                layer.impl_.extract = true;
              } else {
                layer.impl_.extract = false;
              }
              this.ListLayers.filter(obj => obj.type == 'GeoJSON')[0].layers.push(layer.getImpl().name);

            }
          }
        }
      });      
    });
  }
}
